<template>
    <v-container>
        <loading-component :valie="loading"/>
        <v-btn color="primary" @click="new_car_dialog=true">New car</v-btn>
        <v-layout row wrap>
            <v-flex v-for="car in cars" xs12 sm6>
                <v-card style="margin:20px">
                    <v-layout row>
                        <v-flex sm6 xs12>
                            <h3 v-if="car.car_document_front" style="text-align: center">Car Document</h3>
                            <h4 v-else style="text-align: center">No Car Document</h4>
                            <v-img
                                    v-if="car.car_document_front"
                                    class="white--text"
                                    height="200px"
                                    :src="api.MAIN_URL + car.car_document_front">
                            </v-img>
                        </v-flex>
                        <v-divider vertical></v-divider>
                        <v-flex sm6 xs12>
                            <h3 v-if="car.insurance_document_front" style="text-align: center">Insurance Document</h3>
                            <h4 v-else style="text-align: center">No Insurance Document</h4>
                            <v-img
                                    v-if="car.insurance_document_front"
                                    class="white--text"
                                    height="200px"
                                    :src="api.MAIN_URL + car.insurance_document_front">
                            </v-img>
                        </v-flex>
                    </v-layout>
                    <v-divider></v-divider>
                    <v-card-title>
                        <div style="width: 100%">
                            <v-layout row>
                                <v-flex xs5>
                                    <b>Brand</b>
                                </v-flex>
                                <v-flex xs7>
                                    {{car.brand}}
                                </v-flex>
                            </v-layout>
                            <v-layout row>
                                <v-flex xs5>
                                    <b>Model</b>
                                </v-flex>
                                <v-flex xs7>
                                    {{car.model}}
                                </v-flex>
                            </v-layout>
                            <v-layout row>
                                <v-flex xs5>
                                    <b>Color</b>
                                </v-flex>
                                <v-flex xs7>
                                    {{car.color}}
                                </v-flex>
                            </v-layout>
                            <v-layout row>
                                <v-flex xs5>
                                    <b>Number</b>
                                </v-flex>
                                <v-flex xs7>
                                    {{car.number}}
                                </v-flex>
                            </v-layout>
                            <v-layout row>
                                <v-flex xs5>
                                    <b>Car Manufacture Year</b>
                                </v-flex>
                                <v-flex xs7>
                                    {{car.car_manufacture_year}}
                                </v-flex>
                            </v-layout>
                            <v-layout row>
                                <v-flex xs5>
                                    <b>Insurance Expired Date</b>
                                </v-flex>
                                <v-flex xs7>
                                    {{moment(car.insurance_expired_date).format('DD MMM YYYY')}}
                                </v-flex>
                            </v-layout>
                        </div>
                    </v-card-title>
                    <v-card-actions>
                        <!--<v-btn v-if="!car.approved" flat color="primary" @click="openDialog(car.id)">Approve</v-btn>-->
                        <v-btn :disabled="disable" v-if="car.deleted_at" flat color="red" @click="setDefault(car.id)">
                            Set default
                        </v-btn>
                        <v-btn @click="updateInsuranceInfoDialog = car.id,activeCarId =car.id" color="primary">
                            Update Insurance Info
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-flex>
        </v-layout>
        <v-dialog v-model="dialog" width="80%" hide-overlay transition="dialog-bottom-transition">
            <v-card>
                <v-card-title><h3>Approve Car</h3></v-card-title>
                <v-card-text>
                    <car-info ref="car_info" @next_step="done"></car-info>
                </v-card-text>
                <v-btn left color="primary" @click="submit">Approve</v-btn>
            </v-card>
        </v-dialog>

        <v-dialog v-model="new_car_dialog" width="80%" hide-overlay transition="dialog-bottom-transition">
            <v-card>
                <v-card-title><h3>New car</h3></v-card-title>
                <v-card-text>
                    <car-info ref="car_info" @next_step="add"></car-info>
                </v-card-text>
                <v-btn left color="primary" @click="createCar">Create</v-btn>
            </v-card>
        </v-dialog>
        <v-dialog v-model="updateInsuranceInfoDialog">
            <v-card>
                <v-card-title primary-title class="font-weight-bold">
                    Update Insurance Info
                </v-card-title>
                <v-card-text>
                    <v-layout wrap>
                        <v-flex xs12>
                            <choose-date v-model="updateInsuranceDate" label="Insurance Expiry Date"/>
                        </v-flex>
                        <v-flex xs6>
                            <choose-image v-model="updateInsuranceFront" label="Front Insurance Image"/>
                        </v-flex>
                        <v-flex xs6>
                            <choose-image v-model="updateInsuranceBack" label="Back Insurance Image"/>
                        </v-flex>
                    </v-layout>
                </v-card-text>
                <v-btn left color="primary" @click="saveInsuranceInfo">
                    Update Insurance Info
                </v-btn>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
    import CarInfo from "@/components/confirmation_captain_components/CarInfo";
    import ChooseDate from "@/components/wasilni/input/ChooseDate";
    import ChooseImage from "@/components/wasilni/input/ChooseImage";
    import LoadingComponent from "@/components/LoadingComponent";

    export default {
        name: "Cars",
        title: "Cars",
        components: {LoadingComponent, ChooseImage, ChooseDate, CarInfo},
        props: ['captain_id'],
        data() {
            return {
                disable: false,
                dialog: false,
                loading: false,
                new_car_dialog: false,
                cars: [],
                files: {
                    insurance_document: {},
                    car_document: {},
                },
                updateInsuranceInfoDialog: null,
                updateInsuranceDate: null,
                updateInsuranceFront: null,
                updateInsuranceBack: null,
                activeCarId: null
            }
        },
        mounted() {
            this.axios.get(`captain/${this.captain_id}/cars`)
                .then(res => this.cars = res.data.data)
                .catch(err => console.log(err.message))
                .finally(() => this.loading = false);
        },
        methods: {
            async saveInsuranceInfo() {
                const carId = this.activeCarId;

                if (!this.updateInsuranceDate || !this.updateInsuranceBack || !this.updateInsuranceFront) {
                    window.getApp.$emit("SHOW_TOAST", "Please Fill All Fields", "red");
                    return;
                }

                this.loading = true;
                const formData = new FormData();
                formData.append("_method", "PUT");

                formData.append("insurance_expired_date", this.updateInsuranceDate);
                formData.append("insurance_document_front", this.updateInsuranceFront);
                formData.append("insurance_document_back", this.updateInsuranceBack);
                try {
                    await this.axios.post(this.api.ACTIONS.UPDATE_CAR_DATA(carId), formData);
                    this.loading = false;
                    this.updateInsuranceDate = null;
                    this.updateInsuranceBack = null;
                    this.updateInsuranceFront = null;
                    this.updateInsuranceInfoDialog = null;
                    window.getApp.$emit("SHOW_TOAST", "Saved", "green");
                } catch (e) {
                    window.getApp.$emit("SHOW_TOAST", e.response.data.message, "red");
                } finally {
                    this.loading = false;
                }
            },
            done(car) {
                this.update(car);
                this.dialog = false;
            },
            update(car) {
                for (let i = 0; i < this.cars.length; i++) {
                    if (this.cars[i].id === car.id) {
                        this.cars[i] = car;
                        break;
                    }
                }
            },
            add(car) {
                this.cars.push(car);
                this.new_car_dialog = false;
            },
            openDialog(id) {
                this.dialog = true;
                setTimeout(() => {
                    this.$refs.car_info.reset();
                    this.$refs.car_info.update(id, true);
                }, 10);
            },
            submit() {
                this.$refs.car_info.submit();
            },
            setDefault(car_id) {
                this.disable = true;
                this.axios.put(`car/${car_id}/set_default`)
                    .then(() => {
                        this.cars.forEach(car => {
                            if (car.id === car_id) car.deleted_at = null;
                            else car.deleted_at = this.moment().format('YYYY-MM-DD HH:mm:ss');
                        });
                    }).catch(err => console.log(err.message))
                    .finally(() => this.disable = false);
            },
            createCar() {
                this.$refs.car_info.submit(this.captain_id);
            }
        },
        watch: {
            new_car_dialog(val) {
                if (!val) {
                    this.$refs.car_info.reset();
                }
            }
        }
    }
</script>

<style scoped>

</style>